<script>
import moment from 'moment';
import AnswerRating from './AnswerRating';

export default {
  name: 'ConversationItem',
  components: {
    AnswerRating
  },
  props: {
    data: Object
  },
  computed: {
    type() {
      return this.data.user_id ? 'answer' : 'question';
    },
    date() {
      const date = new Date(this.data.created_at);
      return moment(date).format('dddd, Do MMMM YYYY, H:mm');
    },
    hasRating() {
      return Array.isArray(this.data.ratings) && this.data.ratings.length > 0;
    },
    showRating() {
      return this.type === 'answer' && !this.hasRating;
    }
  }
};
</script>

<template>
  <div class="conversation-item" v-bind:class="`conversation-item--${type}`">
    <div class="conversation-item__wrap">
      <header class="conversation-item__header">
        <span class="conversation-item__type" v-if="type === 'question'">{{
          $t('consultingConversation.conversationItemTypeQuestion')
        }}</span>
        <span class="conversation-item__type" v-else>{{
          $t('consultingConversation.conversationItemTypeAnswer')
        }}</span>
        <span class="conversation-item__date">{{ date }}</span>
      </header>
      <div class="conversation-item__body">{{ data.body }}</div>
    </div>
    <answer-rating v-bind:conversationItemId="data.id" v-if="showRating" />
  </div>
</template>

<style lang="scss">
.conversation-item {
  --c-background: #{$color-card-background};
  margin-top: 7rem;
}

.conversation-item--answer {
  --c-background: #{lighten($color-primary, 60%)};
}

.conversation-item__wrap {
  position: relative;
  padding: 2.3rem 5rem;
  background-color: var(--c-background);

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -1.1rem;
    top: 2.1rem;
    width: 2.2rem;
    height: 2.2rem;
    background-color: var(--c-background);
    transform: rotate(45deg);
  }
}

.conversation-item--answer .conversation-item__wrap {
  &::before {
    left: auto;
    right: -1.1rem;
  }
}

.conversation-item__header {
  display: flex;
  justify-content: space-between;
  font-size: 1.4rem;
  color: $color-secondary-alt;
  letter-spacing: 0.04rem;
  text-transform: uppercase;
}

.conversation-item__body {
  margin-top: 2rem;
  font-size: 1.8rem;
  letter-spacing: 0.033rem;
  line-height: 1.56;
  white-space: pre-line;
  overflow-wrap: break-word;
}
</style>
